import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useForm, Controller } from 'react-hook-form'
import TextField from '@mui/material/TextField'
import Button from '@mui/material/Button'
import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'
import FormGroup from '@mui/material/FormGroup'
import FormControlLabel from '@mui/material/FormControlLabel'
import Typography from '@mui/material/Typography'
import Container from '@mui/material/Container'
import Link from '@mui/material/Link'
import LoadingButton from '@mui/lab/LoadingButton'
import AppBar from '@mui/material/AppBar'
import Skeleton from '@mui/material/Skeleton'
import Stack from '@mui/material/Stack'
import Toolbar from '@mui/material/Toolbar'
import IconButton from '@mui/material/IconButton'
import Switch from '@mui/material/Switch'
import SaveIcon from '@mui/icons-material/Save'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import TextareaAutosize from '@mui/base/TextareaAutosize'
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { Error, Spinner } from '../../common/Error';
import { FormSelect, FormSwitch } from '../../common/form'
import Avatar from '../../common/Avatar'
import TopBar from '../../common/TopBar'
import {
  selectUser,
  postFeedback,
} from './authSlice';

export const Feedback = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { loading, error, success } = useSelector((state) => state.auth.feedback)
  const validationSchema = Yup.object().shape({
    text: Yup.string()
      .required('Please leave some constructive feedback')
      .max(1024, 'Feedback cannot exceed 1024 characters')
      .test({
        name: 'is-blank',
        skipAbsent: true,
        test(value, ctx) {
          if (value.trim().length === 0) {
            return ctx.createError({ message: 'You cannot send a blank message' })
          }
          return true
        }
      })
  })
  const {
    register,
    handleSubmit,
    control,
    formState: { isDirty, errors },
    reset,
  } = useForm({
    defaultValues: {
      text: '',
    },
    resolver: yupResolver(validationSchema)
  })

  useEffect(() => {
    if (success) {
      reset()
    }
  }, [success])

  const submitForm = (data) => {
    if (data.text.trim().length === 0) return
    dispatch(postFeedback({ text: data.text.trim() }))
  }

  return (
    <Box component='form' noValidate='noValidate' onSubmit={handleSubmit(submitForm)}>
      <TopBar
        title='Give feedback'
        primaryAction={
          <LoadingButton
            size='medium'
            type='submit'
            variant='contained'
            disabled={!isDirty}
            loading={loading}
          >
            Submit
          </LoadingButton>
        }
      />
      <Container>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <Typography component='p'
            sx={{
              my: 3,
            }}
          >
            Thanks for using Babel Chat! Please leave some feedback so we can improve the experience for you. 
          </Typography>
          <TextField
            id='text'
            name='text'
            placeholder='Leave some constructive feedback'
            {...register('text')}
            error={errors.text ? true : false}
            helperText={errors.text?.message || 'Tell us what you think'}
            fullWidth
            multiline
            required
            disabled={loading}
            minRows={8}
            sx={{
              marginBottom: 2,
            }}
          />
        </Box>
      </Container>
    </Box>
  )
}
